import API from '../../api/api';
import {post} from './NetworkRequestActions';

export function applyCredit(data) {
  return API.doNetworkRequest('/v2/order/invoice/credit', JSON.stringify(data), undefined, 'PUT');
}

export function removeCredit() {
  return API.doNetworkRequest('/v2/order/invoice/credit', null, undefined, 'DELETE');
}

export function getMarketingPreferences(data) {
  return API.doNetworkRequest('/v2/marketing-preferences/display', JSON.stringify(data));
}

export function submitDeviceUpdates(data) {
  return post('/checkout-api/v2/device-update', data);
}

export function submitConfirmation(data) {
  return API.doNetworkRequest('/v2/3ds-confirmation', JSON.stringify(data));
}

export function getPaypalExpressClientId(data) {
  return API.doNetworkRequest('/v2/express/paypal/clientId', JSON.stringify(data));
}

export function getAvailableArvatoOptions(data) {
  return API.doNetworkRequest('/v2/arvato/session', JSON.stringify(data));
}

export function setSelectedAddress(data) {
  return API.doNetworkRequest('/v2/addresses/selectedAddress', JSON.stringify(data));
}

export function editAddress(addressId, data) {
  return API.doNetworkRequest(`/v2/addresses/${addressId}`, JSON.stringify(data), undefined, 'PUT');
}

export function deleteAddress(addressId) {
  return API.doNetworkRequest(`/v2/addresses/${addressId}`, null, undefined, 'DELETE');
}

export function validateApplepayMerchant(data) {
  return API.doNetworkRequest('/v2/applepay/validate-merchant', JSON.stringify(data));
}

export function setApplePayPaymentDetails(data) {
  return API.doNetworkRequest('/v2/applepay/payment-details', JSON.stringify(data));
}

export function getPaymentSessionDetails(camelCasePaymentMethod, data) {
  return API.doNetworkRequest(`/v2/payment/session/${camelCasePaymentMethod}`, JSON.stringify(data));
}

export function getSessionDataForOptty() {
  return API.doNetworkRequest('/v2/optty/session');
}

export function getSessionDataForAdyenV2() {
  return API.doNetworkRequest('/v2/adyenV2/session');
}

export function sendAdyenV2ActionResponse(data) {
  return API.doNetworkRequest('/v2/payment/returnFromHosted/adyenV2', JSON.stringify(data));
}

export function sendRazorpayResponseData(data) {
  return API.doNetworkRequest('/v2/payment/returnFromHosted/razorpay', JSON.stringify(data));
}

export function sendNewpayResponse(data) {
  return API.doNetworkRequest(`/v2/return-from-hosted/newpay?status=${data}`, JSON.stringify({}));
}

export function updateDeliveryCountrySelectionOnAPI(data) {
  return API.doNetworkRequest('/v2/delivery-address/country', JSON.stringify(data));
}

export function updatePaymentOptionSelectionOnAPI(data) {
  return API.doNetworkRequest('/v2/order/invoice/paymentOption', JSON.stringify(data));
}

export function updateDeliveryOptionSelectionOnAPI(data) {
  return API.doNetworkRequest('/v2/delivery/select', JSON.stringify(data));
}

export function createAccountOnAPI(data) {
  return API.doNetworkRequest('/v2/createAccount', JSON.stringify(data));
}

export function getStores(data) {
  return API.doNetworkRequest('/v2/click-and-collect/stores', JSON.stringify(data));
}
